import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        Coded with ❤️ &nbsp;·&nbsp;
        <a
          href="https://github.com/YOUR-USERNAME/shecodes-weather-react"
          target="_blank"
          rel="noopener noreferrer"
        >
          ✦ View on GitHub
        </a>
      </p>
    </footer>
  );
}
